import {StageStatus} from "../detail/types/IOfferGroups";

export const getOfferStageText = (status: StageStatus) => {
    switch (status) {
        case StageStatus.PLANNED: {
            return "Planowany";
        }
        case StageStatus.SOLD: {
            return "Sprzedany";
        }
        case StageStatus.FOR_SALE:
        default: {
            return "W sprzedaży";
        }
    }
};
import {StageStatus} from "../detail/types/IOfferGroups";

export const getOfferStageText = (status: StageStatus) => {
    switch (status) {
        case StageStatus.PLANNED: {
            return "Planowany";
        }
        case StageStatus.SOLD: {
            return "Sprzedany";
        }
        case StageStatus.FOR_SALE:
        default: {
            return "W sprzedaży";
        }
    }
};
